import { uniqueId } from "lodash";
import { formFieldInputs } from "../db/formFields";

const formatFormTemplateField = (
  payload,
  addedIndex,
  newFormTemplate,
  isRepeatable = false
) => {
  const inputs = {};

  if (formFieldInputs[payload?.fieldType])
    formFieldInputs[payload?.fieldType].forEach((input) => {
      if (input.name === "field_code" && !payload?.field_code) {
        let count = 0;
        let fieldCodes = [];

        newFormTemplate
          .flatMap((formTemplate) => formTemplate.fields)
          .forEach((field) => {
            if (field.isRepeatable) {
              field.repeatedFields.forEach((repeatedField) => {
                if (repeatedField.fieldType === payload.fieldType) {
                  fieldCodes.push(repeatedField.field_code);
                  count++;
                }
              });
            } else if (field.fieldType === payload.fieldType) {
              fieldCodes.push(field.field_code);
              count++;
            }
          });

        count++;

        while (fieldCodes.includes(input.defaultValue + count)) count++;

        inputs[input.name] = input.defaultValue + count;

        return;
      }

      inputs[input.name] =
        payload[input.name] ||
        input.defaultOption ||
        input.defaultValue ||
        input.defaultValues;
    });

  if (payload?.fieldIndex !== undefined) {
    payload.fieldIndex = addedIndex;
  }

  if (!payload?.id) {
    payload.id = uniqueId(`${isRepeatable ? `repeatable-field` : `field`}-`);
  }

  payload = {
    ...payload,
    ...inputs,
    conditions: [],
  };

  return payload;
};

export default formatFormTemplateField;
